export default "__VITE_ASSET__K_9pUfQP__"